import React from "react";
import { ArrowRight } from "lucide-react";

const WriteArticles = ({ onGetStarted }) => {
  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Left Image */}
          <div className="flex-1 w-full lg:w-auto flex items-center">
            <img
              src="/images/hyperrank-feature-2.png"
              alt="Deep AI analysis of your writing style"
              className="w-full h-auto"
            />
            </div>

          {/* Right Content with gradient background */}
          <div className="flex-1 lg:max-w-xl flex flex-col justify-center bg-gradient-to-l from-green-50 to-white p-8 lg:p-12 rounded-3xl">
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
              AI-powered content that matches{" "}
              <span className="text-green-500">your brand voice</span>
            </h2>

            <p className="text-gray-600 text-base md:text-lg mb-6 leading-relaxed">
              Our AI learns your unique writing style from your existing content. Every article we generate maintains your brand's authentic voice while being optimized for search rankings and reader engagement.
            </p>

            <button 
              onClick={onGetStarted}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-black border-2 border-green-500 font-semibold rounded-full hover:bg-green-50 transition-colors self-start"
            >
              Start for Free
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WriteArticles;

